<form [formGroup]="cellForm" class="table-editable">
  <ngx-hours-cell-selector class="table-editable__hour-selector" formControlName="from" (onChangeEvent)="updateFromIfNecessary($event)"></ngx-hours-cell-selector>
  <span> - </span>
  <ngx-hours-cell-selector class="table-editable__hour-selector" formControlName="to" (onChangeEvent)="updateToIfNecessary($event)"></ngx-hours-cell-selector>
</form>
